import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchKnowihash,
  putContentFilter,
} from "../../store/actions/knowi-actions";
import { getEncryptedHash } from "../../global/utility/statisticsUtil";

const KnowiChart = ({ widget, divId, widgetIndex, encryptHash }) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const dispatch = useDispatch();
  const Knowi = window?.Knowi;
  const deviceID = "32a2a80c-f2b0-4b67-a783-074674cb7f56";
  const accountID = activeSession?.accountId;
  const [hash, setHash] = useState("");
  const [specificWidget, setSpecificWidget] = useState({});
  const host = window.REACT_APP_KNOWI_HOST;

  const [error, setError] = useState("");

  //const widgetsState = useSelector((state) => state.statisticsReducer);
  const [encryptedHash, setEncryptedHash] = useState(
    encryptHash
  );

  if (widget && Array.isArray(widget) && widget.length > 0) {
    widget.map((value) => {
      if (value?.name === "Line Chart") {
        setSpecificWidget(value);
      }
    });
  }

  useEffect(() =>{
    setEncryptedHash(encryptHash);
  },[encryptHash])
  useEffect(() => {
    if (error) {
      throw new Error(error);
    }
  }, [error]);
  useEffect(() => {
    if (accountID && deviceID) {
      Knowi?.render("#" + divId, {
        type: "shareWidgetSecure", //can be changed to single for dashboard w/ SSO
        hash: encryptedHash,
        dashboard: widget.secureShareUrl, //specificWidget.secureShareUrl, //The Widget (chart) ID and Content Filters from above
        url: host,
        view: {
          filter: true,
          title: false,
        },
      });
    }
  }, [Knowi, host, widget, encryptedHash]);

  return <div className="knowiDiv" id={divId}></div>;
};

export default KnowiChart;
